module.exports = __webpack_public_path__ + "static/fonts/Jura-Medium.bbe368d1.ttf";